import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { useMetaPixel } from './hooks/useMetaPixel';
import { useSEO } from './hooks/useSEO';
// Lazy load below-fold components to reduce initial JS bundle
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionIntro = lazy(() => import('./components/SolutionIntro').then(m => ({
  default: m.SolutionIntro
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  useMetaPixel('904978025482552');
  useSEO({
    title: 'Mega Pack Gestión Organizacional — Profesionalizá tu empresa',
    description: 'El sistema más completo en español para transformar tu PyME en una organización estructurada, eficiente y escalable. 6 tomos, plantillas, herramientas y sistema de control. Desde $19.990.',
    url: 'https://fundamentosorganizacional.fegion.shop',
    image: 'https://cdn.magicpatterns.com/uploads/5q59V8L4m6ADUSNGRFBC9d/ChatGPT_Image_10_mar_2026,_00_45_48.png',
    type: 'website',
    locale: 'es_AR'
  });
  return <div className="min-h-screen bg-[#0b0f1a] text-slate-200 font-sans selection:bg-emerald-500/30 selection:text-white overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPoints data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <ProblemSection data-id="element-5" />
          <SolutionIntro data-id="element-6" />
          <PricingSection data-id="element-7" />
          <GuaranteeSection data-id="element-8" />
          <ForWhomSection data-id="element-9" />
          <FAQSection data-id="element-10" />
          <FinalCTASection data-id="element-11" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-12">
        <FooterSection data-id="element-13" />
      </Suspense>
    </div>;
}